// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"91f73148","654":"dcc4907c","917":"e2db78b3"}[chunkId] + ".chunk.css";
};